import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoMediaPlayerMixin from './KendoMediaPlayerMixin'

export default {
    name: 'kendo-mediaplayer',
    mixins: [ KendoMediaPlayerMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('div', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-mediaplayer-vue-wrapper/src/KendoMediaPlayer/index.js